import { fetchData } from "lib/api";
import { UserDto } from "models";
import { UserReplacementRequest, UserReplacementViewModel } from "models/UserReplacement";

const ControllerUserReplacement = `userReplacement`;
export async function userReplacementUserList(): Promise<UserDto[]>
{
  const url = `${ControllerUserReplacement}/users`;
  const response = await fetchData(url);
  return response;
}

export async function userReplacementList(): Promise<UserReplacementViewModel[]>
{
  const url = `${ControllerUserReplacement}`;
  const response = await fetchData(url);
  return response;
}

export async function userReplacementPost(model: UserReplacementRequest): Promise<UserReplacementViewModel>
{
  const url = `${ControllerUserReplacement}`;
  const response = await fetchData(url, undefined, {
    method: "POST",
    body: JSON.stringify(model),
  });
  return response;
}

export async function userReplacementDelete(model: UserReplacementViewModel): Promise<UserReplacementViewModel>
{
  const url = `${ControllerUserReplacement}`;
  const response = await fetchData(url, undefined, {
    method: "DELETE",
    body: JSON.stringify(model),
  });
  return response;
}

